var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('send-message-form',{attrs:{"receivers":_vm.receivers,"profiles":_vm.computedProfiles,"teams":_vm.teams,"submitting":_vm.submitting,"state":_vm.state},on:{"submit":_vm.onSendMessage}})}
var staticRenderFns = []

export { render, staticRenderFns }